module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src500842655/src/html5-media-tool-angular/~/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.eot
// module chunks = 2